// extracted by mini-css-extract-plugin
export default {"tooltip":"uX-z","arrow":"vX-z"};